import { MovingRow } from 'components/MovingRow'
import React, { useState } from 'react'
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

export const Header = ({
  tenant,
  colorMode,
}: {
  tenant?: any
  colorMode?: 'dark' | 'light'
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 712)
  const [isLarge, setIsLarge] = useState(window.innerWidth > 2000)

  const [headerelementsonscreen, setHeaderelementsonscreen] = useState(
    isMobile ? 4 : isLarge ? 13 : 8
  )

  return (
    <>
      <StyledHeader>
        <div className='headerimage'>
          <MovingRow
            imagefile='icons__row_1.png'
            direction={'right'}
            elementsOnScreen={headerelementsonscreen}
          />
          <MovingRow
            imagefile='icons__row_2.png'
            direction={'left'}
            elementsOnScreen={headerelementsonscreen}
          />
          <MovingRow
            imagefile='icons__row_3.png'
            direction={'right'}
            elementsOnScreen={headerelementsonscreen}
          />
          {isLarge && (
            <MovingRow
              imagefile='icons__row_3.png'
              direction={'left'}
              elementsOnScreen={headerelementsonscreen}
            />
          )}
          <div className='headerimageoverlay' onClick={()=>{
            localStorage.removeItem("alkohol_2024")
            window.location.reload()
          }}></div>
        </div>
      </StyledHeader>
      <TextWidth>
        <Headline>
          {(tenant as any).lang === 'de'
            ? 'Ihr Alkoholkonsum im Vergleich'
            : "Buvez-vous trop d’alcool?"}
        </Headline>
        <Lead>
          {(tenant as any).lang === 'de' ? (
            <>
              Wie viel Bier, Wein und Schnaps trinken Sie im Vergleich mit den
              anderen Leserinnen und Lesern? Und ab wann wird es riskant? Unser Alkoholrechner weiss es.
            </>
          ) : (
            <>
            Quelle quantité de vin et d'alcool fort buvez-vous par rapport aux autres lecteurs et lectrices? Découvrez à partir de quel seuil cela devient risqué pour votre santé grâce à notre calculateur.
            </>
          )}
        </Lead>
        <Authors colorMode={colorMode} className='ContentMetaInfo'>
          <span key={72202328}>
            <a
              href={`https://www.${tenant}.ch/author/${83371228}/marc-brupbacher`}
            >
              Marc Brupbacher
            </a>
          </span>{' '}
          <span key={84880321}>
            <a
              href={`https://www.${tenant}.ch/author/${84880321}/sebastian-broschinski`}
            >
              Sebastian Broschinski
            </a>
          </span>
        </Authors>
      </TextWidth>
    </>
  )
}

const Headline = styled.h1`
  font-family: 'Suez One', serif;
  width: 100%;
  text-align: center;
  font-size: 70px;
  line-height: 1.3em;
  margin-bottom: 15px;
  max-width: 100%;
  @media only screen and (max-width: 711px) {
    font-size: 36px;
  }
`
const Lead = styled.h2`
  font-family: var(--font-sans-serif);
  font-weight: 300;
  font-size: 25px;
  width: 100%;
  text-align: center;
  line-height: 1.3em;
  @media only screen and (max-width: 711px) {
    font-size: 18px;
  }
`
const Authors = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  color: var(--text-color);
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  line-height: 1.8rem;
  width: 100%;
  text-align: center;
  margin-bottom: 60px;
  border-top: ${({ colorMode }) =>
    colorMode === 'dark'
      ? '1px solid var(--gray-2)'
      : '1px solid var(--gray-4)'};
  padding-top: 2rem;
  a {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
  }
  span {
    /* white-space: nowrap; */
  }
  span::after {
    content: ', ';
  }
  span:last-child::after {
    content: '';
  }
`

const StyledHeader = styled.header`
  padding-top: 0;
  position: relative;
  max-width: 100vw;

  .headerimageoverlay {
    /* pointer-events: none; */
    position: absolute;
    z-index: 1001;
    bottom: -50px;
    left: 0;
    width: 100%;
    height: calc(100%);
    line-height: 0;
    background-image: url(${require('../../images/icons__headerquestion.png')});
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: calc(min(30vw, 211px)) auto;
  }
  .headerimage {
    line-height: 0;
    background-color: var(--beige-bright-2);
    margin-bottom: 60px;
    overflow: hidden;
    &::before {
      height: 60px;
    }
  }
  @media only screen and (max-width: 711px) {
    background-size: 300%;
    background-position: center top;
  }
`
